import { Button } from "@mui/material"
import { FieldArray, FormikProps } from "formik"
import { Plus } from "lucide-mui"
import React from "react"

import i18n from "@/i18n"

import SpecialHourItem from "./special_hour_item"

const STYLES = {
  section: "bg-white rounded-lg p-6",
  sectionHeader: "text-xl font-semibold mb-0 mt-0",
  headerRow: "flex justify-between items-start mb-6",
  scheduleList: "flex flex-col gap-3",
  emptyState: "text-gray-500 text-center py-8",
} as const

interface SpecialHour {
  id?: string
  closed: boolean
  startDate: string
  endDate: string
  startTime: string
  endTime: string
}

interface SpecialHoursSectionProps {
  specialHours: SpecialHour[]
  formik: FormikProps<any>
}

const SpecialHoursSection: React.FC<SpecialHoursSectionProps> = ({ specialHours, formik }) => {
  const handleAddException = () => {
    const newException = {
      closed: false,
      startDate: "",
      endDate: "",
      startTime: "09:00",
      endTime: "22:00",
    }
    void formik.setFieldValue("specialHours", [...specialHours, newException])
  }

  return (
    <div className={STYLES.section} data-testid="settings-venue-hours-special-container">
      <div className={STYLES.headerRow}>
        <h2 className={STYLES.sectionHeader}>{i18n.t("app.settings.venues.opening_hours.exceptions")}</h2>
        <Button
          variant="contained"
          color="primary"
          startIcon={<Plus />}
          onClick={handleAddException}
          data-testid="settings-venue-hours-special-btn-add"
        >
          {i18n.t("app.settings.venues.opening_hours.add_exception")}
        </Button>
      </div>

      {specialHours.length === 0 ? (
        <div className={STYLES.emptyState}>{i18n.t("app.settings.venues.opening_hours.no_exceptions")}</div>
      ) : (
        <FieldArray name="specialHours">
          {(arrayHelpers) => (
            <div className={STYLES.scheduleList}>
              {specialHours.map((hour, index) => (
                <SpecialHourItem
                  key={index}
                  itemIndex={index}
                  closed={hour.closed}
                  startDate={hour.startDate}
                  endDate={hour.endDate}
                  startTime={hour.startTime}
                  endTime={hour.endTime}
                  onClosedChange={(closed) => formik.setFieldValue(`specialHours.${index}.closed`, closed)}
                  onStartDateChange={(date) => formik.setFieldValue(`specialHours.${index}.startDate`, date)}
                  onEndDateChange={(date) => formik.setFieldValue(`specialHours.${index}.endDate`, date)}
                  onStartTimeChange={(time) => formik.setFieldValue(`specialHours.${index}.startTime`, time)}
                  onEndTimeChange={(time) => formik.setFieldValue(`specialHours.${index}.endTime`, time)}
                  onRemove={() => arrayHelpers.remove(index)}
                />
              ))}
            </div>
          )}
        </FieldArray>
      )}
    </div>
  )
}

export default SpecialHoursSection
